import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdArrowBackIosNew,
  MdArrowForwardIos,
  MdBookmark,
  MdBookmarkBorder,
  MdMenu,
  MdOutlineShoppingCart,
  MdPause,
  MdPerson,
  MdPersonOutline,
  MdPlayArrow,
  MdRestartAlt,
  MdShoppingCart,
} from "react-icons/md";

import "../styles/Create.css";
import { isEmpty } from "../functions/isEmpty";
import { useLocation, useNavigate, useParams } from "react-router";
import Camera from "../components/Camera";
import { useRef } from "react";
import Spinner from "../components/CTA/Spinner";

export default function Create({
  isMobile,
  apiURL,
  authToken,
  creators,
  services,
  templates,
  reload,
  setReload,
  companyData,
  becomeSellerActive,
  setBecomeSellerActive,
}) {
  let navigate = useNavigate();
  let location = useLocation().pathname;
  let loc = useLocation();

  /* template */
  const { templateid } = useParams();
  const [templateData, setTemplateData] = useState({});
  const [promptertext, setPromptertext] = useState("");
  const [localMediaURL, setLocalMediaURL] = useState("");

  /* upload */
  const [isLoading, setIsLoading] = useState(false);

  /* camera */
  const [recordStreams, setRecordStreams] = useState([]);
  const [photo, setPhoto] = useState();
  const [cameraActive, setCameraActive] = useState(false);

  /* video */
  const [isPlaying, setIsPlaying] = useState(true); // State to track if video is playing
  const videoRef = useRef(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(loc.search);
    const isEdit = queryParams.get("edit") === "true";
    if (!isEmpty(templates) && !isEdit) {
      templates.map((template) => {
        if (template.id == templateid) {
          console.log("template");
          setTemplateData(template);
          setPromptertext(template.prompter_text);
          setCameraActive(true);
        }
      });
    } else if (isEdit && !isEmpty(services)) {
      services.map((service) => {
        if (service.id == templateid) {
          console.log("service");
          setLocalMediaURL(service.video_url);
          setCameraActive(false);

          templates.map((template) => {
            if (service.template_id == template.id) {
              setTemplateData(template);
              setPromptertext(template.prompter_text);
            }
          });
        }
      });
    }
  }, [templates, services]);

  const onPhotoTaken = (photoURL) => {
    if (!isEmpty(photoURL)) {
      setPhoto(photoURL);
    }
  };

  const getVideo = () => {
    navigator.mediaDevices
      .getUserMedia({ video: true, audio: true })
      .then((stream) => {
        setCameraActive(true);
      })
      .catch((err) => {
        console.error("Error accessing the camera: ", err);
        setCameraActive(false);
        alert(
          "Error accessing the camera. Please ensure your browser settings allow camera access and the website is served over HTTPS."
        );
      });
  };

  useEffect(() => {
    if (!isEmpty(photo)) {
      setLocalMediaURL(photo.localURL);
      setCameraActive(false);
      recordStreams.forEach((stream) => {
        stream.getTracks().forEach((track) => track.stop());
      });
      setRecordStreams([]);
    } else if (cameraActive) {
      getVideo();
    }

    return () => {
      recordStreams.forEach((stream) => {
        stream.getTracks().forEach((track) => track.stop());
      });
      setRecordStreams([]);
    };
  }, [photo]);

  const resetCamera = () => {
    setPhoto(null);
    setCameraActive(true);
    setRecordStreams([]);
    setLocalMediaURL("");
  };

  const playPauseVideo = () => {
    const video = videoRef.current;

    if (!video) {
      console.error("Video element not found.");
      return;
    }

    if (isPlaying) {
      video.pause(); // Pause the video
      setIsPlaying(false); // Update state to paused
    } else {
      video.play(); // Play the video
      setIsPlaying(true); // Update state to playing
    }
  };
  // upload image file
  const handleUploadForImage = async () => {
    setIsLoading(true);
    const formData = new FormData();

    if (!isEmpty(photo)) {
      formData.append("files[]", photo.files); // Ensure the photo is appended with the correct key
      const res = await fetch(`${apiURL}/api/images/process.php`, {
        headers: {
          Authorization: `Bearer ${authToken?.JWT}`,
        },
        method: "POST",
        body: formData,
      });

      await res.text().then((value) => removeExistingServiceIfNeeded(value));
    }
  };

  const removeExistingServiceIfNeeded = async (imgURL) => {
    // getserviceID

    const resa = await fetch(
      `${apiURL}/api/services/index.php?id=` + templateid,
      {
        method: "POST",
        headers: {
          //   Authorization: `Bearer ${authToken?.JWT}`,
          "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        body: JSON.stringify({
          status: "0",
        }),
      }
    );

    await resa.text().then((value) => uploadToDB(imgURL));
  };

  const uploadToDB = async (imgURL) => {
    setIsLoading(true);

    let now = Math.floor(Date.now() / 1000);

    if (imgURL != "") {
      const resa = await fetch(`${apiURL}/api/services/index.php`, {
        method: "PUT",
        headers: {
          //   Authorization: `Bearer ${authToken?.JWT}`,
          "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        body: JSON.stringify({
          title: templateData.title,
          createdAt: now,
          video_url: imgURL,
          preview_img_url: convertMp4ToImage(imgURL),
          category_id: templateData.category_id,
          company_price: companyData.priceInstagramStory,
          template_id: templateData.id,
          template_searchTags: templateData.searchTags,
          company_id: companyData.id,
          template_schema_id: templateData.schema_id,
          description: templateData.description,
          company_name: companyData.companyname,
          company_insta_accountname: companyData.instagramProfileURL,
          company_insta_follower: companyData.followerInstagram,
          company_profile_pic: JSON.parse(companyData.pictures)[0].url,
        }),
      });

      await resa.text().then((value) => uploadEnds(value));
    } else {
      alert("Upload Video failed");
    }
  };

  const uploadEnds = () => {
    setReload(!reload);
    setIsLoading(false);
    navigate("/seller");
  };

  const convertMp4ToImage = (fileName) => {
    if (typeof fileName !== "string" || !fileName.endsWith(".mp4")) {
      throw new Error("Invalid input: The string must end with '.mp4'");
    }

    // Remove the '.mp4' extension and append '-img.jpg'
    const newFileName = fileName.slice(0, -4) + "-img.jpg";

    return newFileName;
  };

  useEffect(() => {
    setBecomeSellerActive(false);
  }, []);

  return (
    <div className="create">
      {isMobile ? (
        <div className="create_topnav">
          <div
            className="create_topnav_back"
            onClick={() =>
              !isEmpty(localMediaURL) ? resetCamera() : navigate("/seller")
            }>
            <ArrowBack />
            {!isEmpty(localMediaURL)
              ? "Dein Aufgenommenes Video"
              : "Video aufnehmen"}
          </div>
        </div>
      ) : (
        <div className="create_topnav">
          <div
            className="create_topnav_left_title"
            onClick={() =>
              !isEmpty(localMediaURL) ? resetCamera() : navigate("/seller")
            }>
            <ArrowBackDesktop />{" "}
            {!isEmpty(localMediaURL)
              ? "Dein Aufgenommenes Video"
              : "Video aufnehmen"}
          </div>
        </div>
      )}

      <div className="create_body">
        {cameraActive && (
          <div className="create_body_promptertextbox">
            <div className="create_body_promptertextbox_text">
              {"Vorlesen: "} <br />
              {promptertext}
            </div>
          </div>
        )}

        <Camera
          onVideoRecorded={onPhotoTaken}
          recordStreams={recordStreams}
          turnOffCam={!cameraActive}
          setRecordStreams={setRecordStreams}
          overlayImageSrc={
            isEmpty(templateData.imgURL)
              ? "https://www.developercloud.letsfluence.com/api/images/placeholder/transparent.png"
              : templateData.imgURL
          }
        />
        {!isEmpty(localMediaURL) && (
          <>
            <div className="create_body_videobox">
              <video
                key={"vid"} // Add key prop here
                controls={false}
                preload="metadata"
                id={"videoza"}
                autoPlay={true}
                playsInline={true}
                loop={true}
                muted={false}
                ref={videoRef}
                className="create_body_videobox_video">
                <source
                  key={"videasda"}
                  src={localMediaURL}
                  type={`video/mp4`}
                />
                Your browser does not support the video tag.
              </video>
              <div className="create_body_videobox_offerbar">
                <div className="create_body_videobox_offerbar_top">
                  <div className="create_body_videobox_offerbar_top_row">
                    <div className="create_body_videobox_offerbar_top_row_left">
                      Kategorie
                    </div>
                    <div className="create_body_videobox_offerbar_top_row_right">
                      {!isEmpty(templateData) &&
                        JSON.parse(templateData.category_id)[0]}
                    </div>
                  </div>
                  <div className="create_body_videobox_offerbar_top_row">
                    <div className="create_body_videobox_offerbar_top_row_left">
                      Dein Preis
                    </div>
                    <div className="create_body_videobox_offerbar_top_row_right">
                      {!isEmpty(companyData) && companyData.priceInstagramStory}
                      €
                    </div>
                  </div>
                  <div className="create_body_videobox_offerbar_top_row">
                    <div className="create_body_videobox_offerbar_top_row_left">
                      Werbeart
                    </div>
                    <div className="create_body_videobox_offerbar_top_row_right">
                      Story +{" "}
                      {!isEmpty(templateData) &&
                        templateData.schema_id == 1 &&
                        "Business Card "}
                      {!isEmpty(templateData) &&
                        templateData.schema_id == 2 &&
                        "Exposé "}
                      Publishing
                    </div>
                  </div>
                </div>
                <div className="create_body_videobox_offerbar_bottom">
                  Unternehmen fügen ihr Exposé ein und bezahlen dich das
                  zusammengefügte Video auf deiner Insta Story zu teilen.
                </div>
              </div>
              <div className="create_body_videobox_controlbar">
                <div
                  className="create_body_videobox_controlbar_play"
                  onClick={() => playPauseVideo()}>
                  {isPlaying ? <Pausebutton /> : <Playbutton />}
                </div>
                <div
                  className="create_body_videobox_controlbar_restart"
                  onClick={() => resetCamera()}>
                  <Restartbutton /> Neu aufnehmen
                </div>
                {isLoading ? (
                  <div className="create_body_videobox_controlbar_save">
                    <Spinner />
                  </div>
                ) : (
                  <>
                    {!isEmpty(photo) ? (
                      <div
                        className="create_body_videobox_controlbar_save"
                        onClick={() => handleUploadForImage()}>
                        Speichern
                      </div>
                    ) : (
                      <div className="create_body_videobox_controlbar_saveDisabled">
                        Speichern
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 30px;
  color: #474747;
`;

const ArrowForwardIcon = styled(MdArrowForwardIos)`
  font-size: 18px;
  color: #474747;
`;

const ArrowBack = styled(MdArrowBackIosNew)`
  font-size: 23px;
  color: #474747;
`;

const Playbutton = styled(MdPlayArrow)`
  font-size: 23px;
  color: #474747;
`;

const Pausebutton = styled(MdPause)`
  font-size: 23px;
  color: #474747;
`;

const Restartbutton = styled(MdRestartAlt)`
  font-size: 23px;
  color: #474747;
`;

const ArrowBackDesktop = styled(MdArrowBackIosNew)`
  font-size: 23px;
  color: #474747;
  margin-bottom: -5px;
  margin-right: 5px;
`;
